import {takeEvery} from 'redux-saga/effects'
import {
  BULK_CSV_IMPORT,
  CONFIRM_CSV_IMPORT,
  CREATE_CSV_IMPORT_VENUES,
  DOWNLOAD_CSV_IMPORT_TEMPLATE,
  GET_CSV_IMPORT_SCHEMA,
  GET_CSV_IMPORT_TABLE_SCHEMAS,
  GET_SCHOOL_SYSTEMS,
  GET_SCHOOL_SYSTEMS_DETAILS,
  UPLOAD_CSV_IMPORT_FILE,
} from 'setup/redux/Actions/CsvImport/ActionTypes/ApiActionTypes'

import fetchData from '../../SagaHelper'

function* csvImportSaga() {
  yield takeEvery(GET_CSV_IMPORT_SCHEMA, fetchData)
  yield takeEvery(GET_CSV_IMPORT_TABLE_SCHEMAS, fetchData)
  yield takeEvery(UPLOAD_CSV_IMPORT_FILE, fetchData)
  yield takeEvery(CONFIRM_CSV_IMPORT, fetchData)
  yield takeEvery(BULK_CSV_IMPORT, fetchData)
  yield takeEvery(CREATE_CSV_IMPORT_VENUES, fetchData)
  yield takeEvery(GET_SCHOOL_SYSTEMS, fetchData)
  yield takeEvery(GET_SCHOOL_SYSTEMS_DETAILS, fetchData)
  yield takeEvery(DOWNLOAD_CSV_IMPORT_TEMPLATE, fetchData)
}

export default csvImportSaga
